import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/b2b-portal/src/app/error.tsx");
